export class DadProductPrice {
  id: number;
  amount: number;
  currency: string;
  startDate: Date;

  constructor(id: number, amount: number, currency: string, startDate: Date) {
    this.id = id;
    this.amount = amount;
    this.currency = currency;
    this.startDate = startDate;
  }
}
